export const BROADCAST_CHANNEL = {
  AUTH: {
    NAME: 'auth',
    LOGOUT: 'logout',
  },
}
